/**
 * Start an animation frame loop, calling `onFrame` each frame.
 * @returns A function that cancels the animation.
 */
function animate(onFrame) {
    let rafId;
    let lastTime = performance.now();
    function frame(time) {
        const delta = time - lastTime;
        onFrame(delta, time);
        lastTime = time;
        rafId = requestAnimationFrame(frame);
    }
    rafId = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(rafId);
}

export { animate };
//# sourceMappingURL=animate.js.map
